import React, { useState, useEffect } from 'react';

const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxZL9N5rxe6nV1ZGoFHKTf36URSy2PzuBctC4T40A4cbDx8rSfUqXSTgN0Z8KhclQnFcw/exec";


// ─── DECISION CONFIG ───────────────────────────────────────────────────────────
const DECISION = {
  Supervisor: { label: '⭐ Supervisor', badgeBg: '#ede9fe', badgeColor: '#6d28d9', borderColor: '#7c3aed', rowBg: '#faf5ff', headerBg: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', icon: '⭐' },
  FO:         { label: '✅ Selected (FO)', badgeBg: '#d1fae5', badgeColor: '#065f46', borderColor: '#059669', rowBg: '#f0fdf4', headerBg: 'linear-gradient(135deg, #059669 0%, #34d399 100%)', icon: '✅' },
  'Not Selected': { label: '❌ Not Selected', badgeBg: '#fee2e2', badgeColor: '#991b1b', borderColor: '#dc2626', rowBg: '#fff7f7', headerBg: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)', icon: '❌' },
  Pending:    { label: '⏳ Pending', badgeBg: '#fef3c7', badgeColor: '#92400e', borderColor: '#d97706', rowBg: '#fffbeb', headerBg: 'linear-gradient(135deg, #d97706 0%, #fbbf24 100%)', icon: '⏳' },
};

const getDCfg = (d) => DECISION[d] || DECISION['Pending'];

// ─── SCORE FIELD ───────────────────────────────────────────────────────────────
const ScoreDisplay = ({ value, max, color }) => {
  const pct = Math.min(100, Math.round((Number(value) / Number(max)) * 100));
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '4px' }}>
      <div style={{ flex: 1, height: '8px', background: '#e5e7eb', borderRadius: '99px', overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: '99px' }} />
      </div>
      <span style={{ fontWeight: '700', color, fontSize: '14px', minWidth: '54px' }}>{value} / {max}</span>
    </div>
  );
};

// ─── YES/NO CHIP ───────────────────────────────────────────────────────────────
const YNChip = ({ val }) => {
  if (!val) return <span style={{ color: '#9ca3af', fontSize: '14px' }}>—</span>;
  const isY = String(val).toLowerCase().startsWith('yes');
  return (
    <span style={{
      display: 'inline-block', padding: '3px 12px', borderRadius: '99px', fontSize: '13px', fontWeight: '700',
      background: isY ? '#d1fae5' : '#fee2e2', color: isY ? '#065f46' : '#991b1b'
    }}>
      {isY ? '✓ Yes | ہاں' : '✗ No | نہیں'}
    </span>
  );
};

// ─── QUESTION ROW ──────────────────────────────────────────────────────────────
const QRow = ({ no, eng, urdu, value, isScore, max, color }) => (
  <div style={{ marginBottom: '18px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
    <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>
      {no}. {eng}
    </div>
    <div style={{ fontSize: '15px', color: '#6b7280', marginBottom: '8px', textAlign: 'right', direction: 'rtl', lineHeight: '1.7' }}>
      {urdu}
    </div>
    {isScore
      ? <ScoreDisplay value={value || 0} max={max} color={color || '#1e3a8a'} />
      : <YNChip val={value} />
    }
  </div>
);

// ─── TEXT FIELD ────────────────────────────────────────────────────────────────
const TField = ({ label, value, color }) => (
  <div style={{ marginBottom: '18px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
    <div style={{ fontSize: '12px', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.7px', marginBottom: '6px' }}>{label}</div>
    <div style={{
      display: 'inline-block', padding: '6px 14px', borderRadius: '6px', fontSize: '14px', fontWeight: '600',
      background: color ? `${color}18` : '#f3f4f6', color: color || '#374151',
      border: `1px solid ${color ? `${color}40` : '#e5e7eb'}`
    }}>
      {value || '—'}
    </div>
  </div>
);

// ─── DETAIL VIEW ───────────────────────────────────────────────────────────────
const DetailView = ({ row, onBack }) => {
  const decision = row['Hiring Decision | بھرتی کا فیصلہ'] || 'Pending';
  const dc = getDCfg(decision);
  const name = row['Candidate Name | امیدوار کا نام'] || '—';
  const total = row['Total Score | کل نمبر'] || 0;
  const outOf = row['Out Of | کل ممکنہ نمبر'] || 125;

  const secHeader = (title, urdu, color) => (
    <div style={{ fontSize: '16px', fontWeight: '700', color: color || '#1e3a8a', borderBottom: `2px solid ${color || '#1e3a8a'}30`, paddingBottom: '8px', marginBottom: '18px', marginTop: '10px' }}>
      {title} <span style={{ fontSize: '13px', fontWeight: '400', color: '#9ca3af' }}>| {urdu}</span>
    </div>
  );

  return (
    <div style={{ backgroundColor: '#f3f4f6', minHeight: '100vh', padding: '20px', fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <button onClick={onBack} style={{ backgroundColor: '#374151', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: '700', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px' }}>
        ← Back to List | واپس جائیں
      </button>

      <div style={{ maxWidth: '860px', margin: '0 auto', backgroundColor: 'white', boxShadow: '0 10px 40px rgba(0,0,0,0.12)', borderRadius: '14px', overflow: 'hidden' }}>

        {/* HEADER */}
        <div style={{ background: dc.headerBg, padding: '22px 28px', display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
          <div style={{ width: '52px', height: '52px', borderRadius: '50%', background: 'rgba(255,255,255,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', flexShrink: 0 }}>
            {dc.icon}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '20px', fontWeight: '800', color: 'white' }}>{name}</div>
            <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)', marginTop: '3px' }}>
              {row['Position | عہدہ'] || '—'} · {row['Date | تاریخ'] || ''}
            </div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '32px', fontWeight: '900', color: 'white', lineHeight: 1 }}>
              {total}<span style={{ fontSize: '15px', opacity: 0.7 }}>/{outOf}</span>
            </div>
            <div style={{ background: 'rgba(255,255,255,0.25)', color: 'white', padding: '4px 14px', borderRadius: '50px', fontSize: '13px', fontWeight: '700', marginTop: '6px', border: '1.5px solid rgba(255,255,255,0.4)', display: 'inline-block' }}>
              {dc.label}
            </div>
          </div>
        </div>

        <div style={{ padding: '28px' }}>

          {/* EMPLOYEE INFO */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '14px', marginBottom: '30px', backgroundColor: '#f8fafc', padding: '18px', borderRadius: '10px', border: '1px solid #e5e7eb' }}>
            {[
              { l: 'Candidate Name', u: 'امیدوار کا نام', k: 'Candidate Name | امیدوار کا نام' },
              { l: 'Father\'s Name', u: 'والد کا نام', k: "Father's Name | والد کا نام" },
              { l: 'Age', u: 'عمر', k: 'Age | عمر' },
              { l: 'CNIC', u: 'شناختی کارڈ', k: 'CNIC | شناختی کارڈ' },
              { l: 'Contact', u: 'رابطہ نمبر', k: 'Contact No. | رابطہ نمبر' },
              { l: 'Position', u: 'عہدہ', k: 'Position | عہدہ' },
              { l: 'Address', u: 'پتہ', k: 'Address | پتہ' },
              { l: 'Area / Site', u: 'علاقہ / سائٹ', k: 'Area/Site | علاقہ / سائٹ' },
              { l: 'Date', u: 'تاریخ', k: 'Date | تاریخ' },
            ].map((f, i) => (
              <div key={i}>
                <div style={{ fontSize: '11px', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '3px' }}>{f.l} | {f.u}</div>
                <div style={{ fontSize: '14px', fontWeight: '700', color: '#111827' }}>{row[f.k] || '—'}</div>
              </div>
            ))}
          </div>

          {/* SECTION 1: TECHNICAL */}
          {secHeader('1. Technical Knowledge', 'تکنیکی علم', '#2563eb')}
          <TField label="Knowledge Level | تکنیکی علم کی سطح" value={row['Q1. Technical Knowledge Level | تکنیکی علم']} color="#2563eb" />
          <QRow no="Q1 Score" eng="Technical Score" urdu="تکنیکی نمبر" isScore value={row['Q1. Technical Score (Max 15)']} max={15} color="#2563eb" />

          {/* SECTION 2: EXPERIENCE */}
          {secHeader('2. Work Experience', 'کام کا تجربہ', '#7c3aed')}
          <TField label="Experience Level | تجربے کی مدت" value={row['Q2. Work Experience | کام کا تجربہ']} color="#7c3aed" />
          <QRow no="Q2 Score" eng="Experience Score" urdu="تجربے کے نمبر" isScore value={row['Q2. Experience Score (Max 20)']} max={20} color="#7c3aed" />

          {/* SECTION 3: QUALIFICATION */}
          {secHeader('3. Qualification & Extras', 'قابلیت اور اضافی سرٹیفکیٹ', '#0891b2')}
          <TField label="Qualification | تعلیمی قابلیت" value={row['Q3. Qualification | تعلیمی قابلیت']} color="#0891b2" />
          <QRow no="Q3 Score" eng="Qualification Score" urdu="قابلیت کے نمبر" isScore value={row['Q3. Qualification Score (Max 20)']} max={20} color="#0891b2" />
          <div style={{ marginBottom: '18px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
            <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>Extra Certificates (Solar/Safety) | اضافی سرٹیفکیٹ</div>
            <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '8px', textAlign: 'right', direction: 'rtl' }}>سولر / سیفٹی اضافی سرٹیفکیٹ</div>
            <YNChip val={row['Q3b. Extra Certificates - Solar/Safety | اضافی سرٹیفکیٹ']} />
            {row['Q3b. Extra Cert Score (Max 5)'] > 0 && (
              <span style={{ marginLeft: '10px', fontSize: '13px', fontWeight: '700', color: '#0891b2' }}>+{row['Q3b. Extra Cert Score (Max 5)']} pts</span>
            )}
          </div>

          {/* SECTION 4: AREA & MOBILITY */}
          {secHeader('4. Area, Communication & Mobility', 'علاقہ، مواصلات اور نقل و حرکت', '#059669')}
          {[
            { eng: 'Outdoor Work (heat/dust)', urdu: 'بیرونی کام (گرمی / مٹی)', k: 'Q4a. Outdoor Work (heat/dust) | بیرونی کام' },
            { eng: 'Physical Fitness', urdu: 'جسمانی صحت', k: 'Q4b. Physical Fitness | جسمانی صحت' },
            { eng: 'Local Site/Route Knowledge', urdu: 'مقامی راستوں کا علم', k: 'Q4c. Local Site/Route Knowledge | مقامی راستوں کا علم' },
            { eng: 'Willingness to Travel / Night Duty', urdu: 'سفر / رات کی ڈیوٹی', k: 'Q4d. Willingness to Travel/Night Duty | سفر / رات کی ڈیوٹی' },
            { eng: 'Read & Write Urdu', urdu: 'اردو لکھنا اور پڑھنا', k: 'Q4e. Read & Write Urdu | اردو لکھنا پڑھنا' },
            { eng: 'Read & Write English', urdu: 'انگریزی لکھنا اور پڑھنا', k: 'Q4f. Read & Write English | انگریزی لکھنا پڑھنا' },
            { eng: 'Can Drive a Bike', urdu: 'بائیک چلا سکتا ہے', k: 'Q4g. Can Drive a Bike | بائیک چلا سکتا ہے' },
          ].map((q, i) => (
            <div key={i} style={{ marginBottom: '18px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>Q4{String.fromCharCode(97+i)}) {q.eng}</div>
              <div style={{ fontSize: '15px', color: '#6b7280', marginBottom: '8px', textAlign: 'right', direction: 'rtl' }}>{q.urdu}</div>
              <YNChip val={row[q.k]} />
            </div>
          ))}
          <QRow no="Q4 Score" eng="Area & Mobility Score" urdu="علاقہ اور نقل و حرکت کے نمبر" isScore value={row['Q4. Area & Mobility Score (Max 45)']} max={45} color="#059669" />

          {/* SECTION 5: SAFETY */}
          {secHeader('5. Safety, Discipline & Digital', 'حفاظت، نظم و ضبط اور ڈیجیٹل', '#dc2626')}
          {[
            { eng: 'Use of PPE', urdu: 'حفاظتی سامان کا استعمال', k: 'Q5a. Use of PPE | حفاظتی سامان کا استعمال' },
            { eng: 'Electrical & Height Safety', urdu: 'بجلی اور اونچائی کی حفاظت', k: 'Q5b. Electrical & Height Safety | بجلی اور اونچائی' },
            { eng: 'Discipline & SOP Compliance', urdu: 'نظم و ضبط اور ایس او پی', k: 'Q5c. Discipline & SOP Compliance | نظم و ضبط' },
            { eng: 'Smartphone / Laptop Use', urdu: 'اسمارٹ فون / لیپ ٹاپ کا استعمال', k: 'Q5d. Smartphone / Laptop Use | ڈیجیٹل مہارت' },
          ].map((q, i) => (
            <div key={i} style={{ marginBottom: '18px', paddingBottom: '15px', borderBottom: '1px dashed #e5e7eb' }}>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>Q5{String.fromCharCode(97+i)}) {q.eng}</div>
              <div style={{ fontSize: '15px', color: '#6b7280', marginBottom: '8px', textAlign: 'right', direction: 'rtl' }}>{q.urdu}</div>
              <YNChip val={row[q.k]} />
            </div>
          ))}
          <QRow no="Q5 Score" eng="Safety & Discipline Score" urdu="حفاظت اور نظم و ضبط کے نمبر" isScore value={row['Q5. Safety & Discipline Score (Max 20)']} max={20} color="#dc2626" />

          {/* FINAL RESULT */}
          <div style={{ marginTop: '30px', background: 'linear-gradient(135deg, #0f172a, #1e3a8a)', borderRadius: '12px', padding: '22px 24px', color: 'white' }}>
            <div style={{ fontSize: '13px', color: '#93c5fd', textTransform: 'uppercase', letterSpacing: '1.2px', marginBottom: '6px' }}>Final Result | حتمی نتیجہ</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '14px' }}>
              <div>
                <div style={{ fontSize: '36px', fontWeight: '900', lineHeight: 1 }}>{total}<span style={{ fontSize: '18px', opacity: 0.6, fontWeight: '400' }}>/{outOf}</span></div>
                <div style={{ fontSize: '13px', color: '#93c5fd', marginTop: '4px' }}>Total Score | کل نمبر</div>
              </div>
              <div style={{ background: dc.headerBg, padding: '10px 24px', borderRadius: '50px', fontWeight: '800', fontSize: '16px', border: '2px solid rgba(255,255,255,0.3)', boxShadow: '0 0 20px rgba(0,0,0,0.3)' }}>
                {dc.label}
              </div>
            </div>
            {row['Remarks | ریمارکس'] && (
              <div style={{ marginTop: '16px', background: 'rgba(255,255,255,0.08)', padding: '12px 16px', borderRadius: '8px', borderLeft: '3px solid rgba(255,255,255,0.3)' }}>
                <div style={{ fontSize: '11px', color: '#93c5fd', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '4px' }}>Remarks | ریمارکس</div>
                <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.9)', fontStyle: 'italic' }}>"{row['Remarks | ریمارکس']}"</div>
              </div>
            )}
            {row['Evaluator Name | جائزہ لینے والے کا نام'] && (
              <div style={{ marginTop: '12px', fontSize: '12px', color: '#93c5fd' }}>
                Evaluated by: <span style={{ color: 'white', fontWeight: '600' }}>{row['Evaluator Name | جائزہ لینے والے کا نام']}</span>
                {row['Submitted At | جمع کرانے کا وقت'] && <span style={{ opacity: 0.6 }}> · {row['Submitted At | جمع کرانے کا وقت']}</span>}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

// ─── MAIN COMPONENT ────────────────────────────────────────────────────────────
const HiringDashboard = () => {
  const [view, setView] = useState('list');
  const [selected, setSelected] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('All');
  const [search, setSearch] = useState('');

  const fetchData = async () => {
    setLoading(true); setError(null);
    try {
      const res = await fetch(GOOGLE_SCRIPT_URL);
      const json = await res.json();
      if (json.error) throw new Error(json.error);
      // Support both {success, data:[]} and direct array
      const arr = Array.isArray(json) ? json : (json.data || []);
      setData([...arr].reverse());
    } catch (e) {
      setError(e.message || 'Data load nahi ho saka.');
    }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  if (view === 'detail') return <DetailView row={selected} onBack={() => { setSelected(null); setView('list'); }} />;

  const counts = {
    Supervisor: data.filter(r => r['Hiring Decision | بھرتی کا فیصلہ'] === 'Supervisor').length,
    FO: data.filter(r => r['Hiring Decision | بھرتی کا فیصلہ'] === 'FO').length,
    'Not Selected': data.filter(r => r['Hiring Decision | بھرتی کا فیصلہ'] === 'Not Selected').length,
  };

  const filtered = data.filter(row => {
    const d = row['Hiring Decision | بھرتی کا فیصلہ'] || 'Pending';
    const matchF = filter === 'All' || d === filter;
    const n = (row['Candidate Name | امیدوار کا نام'] || '').toLowerCase();
    const p = (row['Position | عہدہ'] || '').toLowerCase();
    return matchF && (!search || n.includes(search.toLowerCase()) || p.includes(search.toLowerCase()));
  });

  return (
    <div style={{ backgroundColor: '#f1f5f9', minHeight: '100vh', padding: '24px', fontFamily: "'Segoe UI', system-ui, sans-serif" }}>

      {/* PAGE HEADER */}
      <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '14px' }}>
        <div>
          <h1 style={{ fontSize: '26px', fontWeight: '900', color: '#0f172a', margin: 0, letterSpacing: '-0.5px' }}>
            📋 Hiring Applications
          </h1>
          <p style={{ color: '#6b7280', margin: '5px 0 0', fontSize: '14px' }}>
            ملازم بھرتی ڈیش بورڈ · Total Candidates: <strong>{data.length}</strong>
          </p>
        </div>
        <button onClick={fetchData} disabled={loading} style={{ backgroundColor: '#1e3a8a', color: 'white', padding: '10px 22px', border: 'none', borderRadius: '9px', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer', fontSize: '14px', boxShadow: '0 2px 10px rgba(30,58,138,0.3)' }}>
          {loading ? '⏳ Loading...' : '🔄 Refresh Data'}
        </button>
      </div>

      {/* STAT CARDS */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px', marginBottom: '22px' }}>
        {[
          { label: 'Total', count: data.length, icon: '👥', color: '#1e3a8a', bg: '#eff6ff' },
          { label: 'Supervisor', count: counts.Supervisor, icon: '⭐', color: '#6d28d9', bg: '#f5f3ff' },
          { label: 'FO Selected', count: counts.FO, icon: '✅', color: '#059669', bg: '#f0fdf4' },
          { label: 'Not Selected', count: counts['Not Selected'], icon: '❌', color: '#dc2626', bg: '#fff7f7' },
        ].map((s, i) => (
          <div key={i} style={{ background: s.bg, border: `1.5px solid ${s.color}30`, borderRadius: '12px', padding: '16px', cursor: 'pointer' }} onClick={() => setFilter(s.label === 'Total' ? 'All' : s.label === 'FO Selected' ? 'FO' : s.label)}>
            <div style={{ fontSize: '22px', marginBottom: '6px' }}>{s.icon}</div>
            <div style={{ fontSize: '30px', fontWeight: '900', color: s.color, lineHeight: 1 }}>{s.count}</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px', fontWeight: '600' }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* SEARCH + FILTER */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '18px', flexWrap: 'wrap', alignItems: 'center' }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Search by name or position..."
          style={{ flex: 1, minWidth: '200px', padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: '9px', background: 'white', fontSize: '14px', outline: 'none' }} />
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
          {[
            { val: 'All', label: `All (${data.length})`, color: '#1e3a8a' },
            { val: 'Supervisor', label: `⭐ Supervisor (${counts.Supervisor})`, color: '#7c3aed' },
            { val: 'FO', label: `✅ FO (${counts.FO})`, color: '#059669' },
            { val: 'Not Selected', label: `❌ Not Selected (${counts['Not Selected']})`, color: '#dc2626' },
          ].map(btn => (
            <button key={btn.val} onClick={() => setFilter(btn.val)} style={{
              padding: '8px 14px', borderRadius: '50px', fontSize: '12px', cursor: 'pointer',
              border: `1.5px solid ${filter === btn.val ? btn.color : '#d1d5db'}`,
              background: filter === btn.val ? btn.color : 'white',
              color: filter === btn.val ? 'white' : '#4b5563',
              fontWeight: filter === btn.val ? '700' : '500',
            }}>{btn.label}</button>
          ))}
        </div>
      </div>

      {/* ERROR */}
      {error && (
        <div style={{ background: '#fef2f2', border: '1.5px solid #fca5a5', borderRadius: '10px', padding: '16px 20px', marginBottom: '18px', color: '#991b1b', fontSize: '14px', fontWeight: '600' }}>
          ❌ {error} — Make sure your Apps Script supports GET and is deployed as "Anyone can access".
        </div>
      )}

      {/* TABLE */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#9ca3af', fontSize: '16px' }}>⏳ Loading data...</div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#9ca3af', background: 'white', borderRadius: '12px', fontSize: '15px' }}>No records found.</div>
      ) : (
        <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 16px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
          {/* Table Header */}
          <div style={{ display: 'grid', gridTemplateColumns: '0.4fr 2fr 1.5fr 1fr 1fr 1fr', padding: '13px 20px', background: '#f8fafc', borderBottom: '2px solid #e5e7eb', fontWeight: '700', fontSize: '12px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.7px' }}>
            <div>#</div>
            <div>Candidate Name | نام</div>
            <div>Position | عہدہ</div>
            <div>Score | نمبر</div>
            <div>Decision | فیصلہ</div>
            <div>Action</div>
          </div>

          {/* Rows */}
          {filtered.map((row, i) => {
            const d = row['Hiring Decision | بھرتی کا فیصلہ'] || 'Pending';
            const dc = getDCfg(d);
            const total = row['Total Score | کل نمبر'] || 0;
            return (
              <div
                key={i}
                onClick={() => { setSelected(row); setView('detail'); }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = dc.rowBg}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'}
                style={{ display: 'grid', gridTemplateColumns: '0.4fr 2fr 1.5fr 1fr 1fr 1fr', padding: '14px 20px', borderBottom: '1px solid #f1f5f9', alignItems: 'center', cursor: 'pointer', transition: 'background 0.15s', fontSize: '14px', color: '#1f2937' }}>
                <div style={{ color: '#9ca3af', fontWeight: '700' }}>{filtered.length - i}</div>
                <div style={{ fontWeight: '700' }}>{row['Candidate Name | امیدوار کا نام'] || '—'}</div>
                <div>
                  <span style={{ background: '#e0e7ff', color: '#3730a3', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '700' }}>
                    {row['Position | عہدہ'] || '—'}
                  </span>
                </div>
                <div style={{ fontWeight: '800', color: '#1e3a8a', fontSize: '15px' }}>
                  {total}<span style={{ fontSize: '11px', color: '#9ca3af', fontWeight: '400' }}>/125</span>
                </div>
                <div>
                  <span style={{ background: dc.badgeBg, color: dc.badgeColor, padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '700', border: `1px solid ${dc.borderColor}40` }}>
                    {dc.label}
                  </span>
                </div>
                <div>
                  <button style={{ backgroundColor: '#eff6ff', color: '#1e40af', padding: '6px 14px', borderRadius: '7px', border: 'none', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
                    View Details
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default HiringDashboard;